import {CFormInput} from "@coreui/react";
import React from "react";

export default (props) => {

	const handleChange = (e) => {
		const updateRowData = {
			...props.data, value: e.target.value
		}
		props.onEventChange(props.rowIndex, updateRowData);
	}

	return (
		<div>
			<input type={'text'} value={props.data.value} onChange={handleChange} />
		</div>
	)
}
